import { useApp } from "@/context/AppContext";

export default function AnnouncementBar() {
  const { settings } = useApp();
  if (!settings || !settings.announcement_enabled) return null;
  const text = settings.announcement_bar || "";
  const items = text.split("•").map((s) => s.trim()).filter(Boolean);
  const doubled = [...items, ...items, ...items, ...items];
  return (
    <div data-testid="announcement-bar" className="bg-white text-black border-b border-black/10 overflow-hidden">
      <div className="flex whitespace-nowrap marquee-track py-2">
        {doubled.map((t, i) => (
          <div key={`${t}-${i}`} className="flex items-center gap-6 pr-10">
            <span className="w-1.5 h-1.5 bg-[#E63946]"></span>
            <span className="overline">{t}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
